function appstleBundleSelect() {
  const bundleOptions = document.querySelectorAll('.ab-volume-discount-item-container');
  const subscriptionWidget = document.querySelector('#appstle_subscription_widget0');
  if (!subscriptionWidget || !bundleOptions.length) return;

  const subsDiscountElement = subscriptionWidget.querySelector('.appstle-save-badge');
  // const subsDiscountDetails = subscriptionWidget.querySelector('.dm-subscription-details');
  // const subsDiscountDetailsBenefit = subsDiscountDetails?.querySelectorAll('.OrderTypeField_OrderTypeField__benefit__V6ki4') || [];
  // const subsDiscountDetailsBenefitIcon = `
  //   <span class="Icon_Icon__dsocX" style="width: 18px; height: 18px;">
  //     <svg aria-hidden="false" focusable="true" width="24" height="24" viewBox="0 0 24 24" fill="none"
  //       xmlns="http://www.w3.org/2000/svg">
  //       <path fill-rule="evenodd" clip-rule="evenodd"
  //         d="M22.5 11.75C22.5 17.6871 17.6871 22.5 11.75 22.5C5.81294 22.5 1 17.6871 1 11.75C1 5.81294 5.81294 1 11.75 1C17.6871 1 22.5 5.81294 22.5 11.75ZM15.2803 10.2803C15.5732 9.98744 15.5732 9.51256 15.2803 9.21967C14.9874 8.92678 14.5126 8.92678 14.2197 9.21967L10.75 12.6893L9.28033 11.2197C8.98744 10.9268 8.51256 10.9268 8.21967 11.2197C7.92678 11.5126 7.92678 11.9874 8.21967 12.2803L10.2197 14.2803C10.5126 14.5732 10.9874 14.5732 11.2803 14.2803L15.2803 10.2803Z"
  //         fill="#0C0C0D"></path>
  //     </svg>
  //   </span>`;

  const subsDiscountNumber = 20;
  // const subsDiscountDetailsBenefit2 = subsDiscountDetailsBenefit[1];

  bundleOptions.forEach(bundle => {
    bundle.addEventListener('click', (e) => {
      e.preventDefault();
      setTimeout(() => {
        if (bundle.classList.contains('ab-volume-discount-item-selected')) {
          const priceElement = document.querySelector('.product .price .price__regular .price-item--sale .money');
          if (!priceElement) return;

          const oneTimeSalePrice = parseFloat(priceElement.innerText.replace('$', ''));
          const subsSalePriceElement = subscriptionWidget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount .money');
          const subsComparePriceElement = subscriptionWidget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_compare_amount .money');
          const oneTimeSalePriceElement = subscriptionWidget.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount .money');

          const subsSalePrice = oneTimeSalePrice - (oneTimeSalePrice * subsDiscountNumber / 100);
          const bundleCountText = bundle.querySelector('.ab-volume-discount-item-title-label')?.innerText || '';
          const bundleCount = parseFloat(bundleCountText.match(/\d+(\.\d+)?/)?.[0] || 1);

          const bundleDiscountElement = bundle.querySelector('.ab-volume-discount-item-save-subtitle-label');
          const bundleDiscountText = bundleDiscountElement?.innerText || '';
          var bundleDiscountNumber = parseFloat(bundleDiscountText.match(/\d+(\.\d+)?/)?.[0] || 0);

          const bundleSubsSalePrice = subsSalePrice * bundleCount;
          const bundleOneTimeSalePrice = oneTimeSalePrice * bundleCount;
          if (bundleCount === 3) {
            bundleDiscountNumber = 10;
          }
          else if (bundleCount === 4) {
            bundleDiscountNumber = 15;
          }
          else if (bundleCount === 5) {
            bundleDiscountNumber = 20;
          }

          const bundleSubsDiscountAmount = Math.round(bundleSubsSalePrice - (bundleSubsSalePrice * bundleDiscountNumber / 100));
          const bundleOneTimeDiscountAmount = Math.round(bundleOneTimeSalePrice - (bundleOneTimeSalePrice * bundleDiscountNumber / 100));

          const subsBundleDiscount = subsDiscountNumber + bundleDiscountNumber;
          subsDiscountElement.innerText = `SAVE ${subsBundleDiscount}%`;

          // if (subsDiscountDetailsBenefit2) {
          //   subsDiscountDetailsBenefit2.innerHTML = `${subsDiscountDetailsBenefitIcon} Save ${subsBundleDiscount}% on Every Order`;
          // }

          if (subsSalePriceElement) {
            subsSalePriceElement.innerText = `$${bundleSubsDiscountAmount}`;
          }

          if (subsComparePriceElement) {
            subsComparePriceElement.innerText = `$${bundleOneTimeDiscountAmount}`;
          }

          if (oneTimeSalePriceElement) {
            oneTimeSalePriceElement.innerText = `$${bundleOneTimeDiscountAmount}`;
          }
        }
        // else {
        //   if (subsDiscountDetailsBenefit2) {
        //     subsDiscountDetailsBenefit2.innerHTML = `${subsDiscountDetailsBenefitIcon} Save ${subsDiscountNumber}% on Every Order`;
        //   }
        // }
      }, 800);
    });
  });
}

  var sellingPlanSelectedCount = 1;
  var sellingPlanDeSelectedCount = 1;
  var sellingPlanSelected = true;
  var sellingPlanDeSelected = true;

  document.addEventListener('appstleRecalculateBundle', (e) => {
    const selectedBundle = document.querySelector('.ab-volume-discount-item-selected');
    if (selectedBundle) {
      sellingPlanSelected = true;
      sellingPlanSelectedCount = 1;
      sellingPlanDeSelected = true;
      sellingPlanDeSelectedCount = 1;
      selectedBundle.dispatchEvent(new Event('click', { bubbles: true }));
      selectedBundle.dispatchEvent(new Event('click', { bubbles: true }));
    }
  });

  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected', function () {
    const bundleOptions = document.querySelectorAll('.ab-volume-discount-item-container');
    if (sellingPlanDeSelectedCount == 1 && sellingPlanDeSelected) {
      bundleOptions.forEach(bundle => {
        const bundleDiscountElement = bundle.querySelector('.ab-volume-discount-item-save-subtitle-label');
        const bundleCountText = bundle.querySelector('.ab-volume-discount-item-title-label')?.innerText || '';
        const bundleCount = parseFloat(bundleCountText.match(/\d+(\.\d+)?/)?.[0] || 1);
        var oneTimeDiscountNumber = 0;
        if (bundleCount === 3) {
          oneTimeDiscountNumber = 10;
        }
        else if (bundleCount === 4) {
          oneTimeDiscountNumber = 15;
        }
        else if (bundleCount === 5) {
          oneTimeDiscountNumber = 20;
        }
        const oneTimeDiscount = oneTimeDiscountNumber;
        if (bundleDiscountElement) {
          bundleDiscountElement.innerText = `Save ${oneTimeDiscount}%`;
        }
      });
      console.log("Selling Plan DeSelected");
      sellingPlanDeSelectedCount++;
      sellingPlanDeSelected = false;
    }
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('appstleRecalculateBundle', {
        detail: { source: 'plan-change' }
      }));
    }, 300);
  });

  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function () {
    const bundleOptions = document.querySelectorAll('.ab-volume-discount-item-container');
    // if (sellingPlanSelectedCount == 1 && sellingPlanSelected) {
      bundleOptions.forEach(bundle => {
        const subsDiscountNumber = 20;
        const bundleDiscountElement = bundle.querySelector('.ab-volume-discount-item-save-subtitle-label');
        const bundleCountText = bundle.querySelector('.ab-volume-discount-item-title-label')?.innerText || '';
        const bundleCount = parseFloat(bundleCountText.match(/\d+(\.\d+)?/)?.[0] || 1);
        var bundleDiscountNumber = 0;
        if (bundleCount === 3) {
          bundleDiscountNumber = 10;
        }
        else if (bundleCount === 4) {
          bundleDiscountNumber = 15;
        }
        else if (bundleCount === 5) {
          bundleDiscountNumber = 20;
        }
        const subsBundleDiscount = subsDiscountNumber + bundleDiscountNumber;
        if (bundleDiscountElement) {
          console.log(subsBundleDiscount)
          bundleDiscountElement.innerText = `Save ${subsBundleDiscount}%`;
        }
      });
      console.log("Selling Plan Selected");
      sellingPlanSelectedCount++;
      sellingPlanSelected = false;
    // }
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('appstleRecalculateBundle', {
        detail: { source: 'plan-change' }
      }));
    }, 300);
  });

  window.addEventListener('appstleBundlesAppliedVolumeDiscount', () => {
    appstleBundleSelect();
  });
